var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 76
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D38",
    d: "M0 19v38c0 10.493 8.507 19 19 19h35c10.493 0 19-8.507 19-19V19C73 8.507 64.493 0 54 0H19C8.507 0 0 8.507 0 19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M51.21 33.417h-1.42v-5.042C49.79 21.54 44.062 16 37 16c-7.063 0-12.79 5.54-12.79 12.375v5.042h-1.42c-2.093 0-3.79 1.641-3.79 3.666v19.25C19 58.358 20.697 60 22.79 60h28.42c2.093 0 3.79-1.642 3.79-3.667v-19.25c0-2.025-1.697-3.666-3.79-3.666zM33 44.727c-.009-1.803 1.38-3.35 3.293-3.668 1.913-.319 3.796.684 4.463 2.377.668 1.692-.073 3.585-1.756 4.486v4.223C39 53.17 38.104 54 37 54c-1.105 0-2-.83-2-1.855v-4.223c-1.234-.658-1.996-1.876-2-3.195zm-4-15.834C29 24.533 32.582 21 37 21s8 3.534 8 7.893v4.178a.935.935 0 01-.941.929H29.94a.935.935 0 01-.941-.929v-4.178z"
  }))));
}
export default SvgSignUpLock;